import { createSlice } from '@reduxjs/toolkit';
import { SYNC_SEARCH_TERM } from '../search/actions/searchActionTypes';
import { VIEW_PIPELINE_CHANGED, SORT_CHANGED, QUICK_FILTERS_CHANGED, QUICK_FILTER_PROPERTIES_CHANGED, FILTER_GROUPS_CHANGED, RESET_VIEW, COLUMNS_CHANGED } from '../../views/actions/viewsActionTypes';
import { PIPELINE_CHANGED } from '../pipelines/slice/currentPipelineIdSlice';
import { RESTORE_CACHED_VALUES } from '../init/actions/initActionTypes';
// Define an action matcher for sync actions
export const isSyncAction = action => action.type === SYNC_SEARCH_TERM || action.type === VIEW_PIPELINE_CHANGED || action.type === SORT_CHANGED || action.type === QUICK_FILTERS_CHANGED || action.type === QUICK_FILTER_PROPERTIES_CHANGED || action.type === FILTER_GROUPS_CHANGED || action.type === RESET_VIEW || action.type === PIPELINE_CHANGED || action.type === RESTORE_CACHED_VALUES;
// Type guard for actions that can be synchronized
export const isSyncActionWithPayload = action => isSyncAction(action);

// Same idea, but for table config
export const isTableConfigSyncAction = action => action.type === COLUMNS_CHANGED || action.type === RESTORE_CACHED_VALUES;
export const isTableConfigSyncActionWithPayload = action => isTableConfigSyncAction(action);
const initialState = {
  segmentSyncLog: [],
  tableConfigSyncLog: []
};

// Helper to check if an action should be synced
const shouldSync = action => {
  // Check if skipSync property exists on payload and is true
  return !('skipSync' in action.payload && action.payload.skipSync === true);
};
export const vizCoreBridgeSlice = createSlice({
  name: 'vizCoreBridge',
  initialState,
  reducers: {
    clearProcessedLogs: (state, action) => {
      state.segmentSyncLog = state.segmentSyncLog.slice(action.payload);
    },
    clearTableConfigProcessedLogs: (state, action) => {
      state.tableConfigSyncLog = state.tableConfigSyncLog.slice(action.payload);
    }
  },
  extraReducers: builder => {
    builder
    // Use matcher to handle all supported sync actions with the same logic
    .addMatcher(isSyncActionWithPayload, (state, action) => {
      // Skip adding to the log if skipSync is true
      if (shouldSync(action)) {
        state.segmentSyncLog.push(action);
      }
    }).addMatcher(isTableConfigSyncActionWithPayload, (state, action) => {
      if (shouldSync(action)) {
        state.tableConfigSyncLog.push(action);
      }
    });
  }
});
export const {
  clearProcessedLogs,
  clearTableConfigProcessedLogs
} = vizCoreBridgeSlice.actions;
export default vizCoreBridgeSlice.reducer;